import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { getControls } from '../../../actions/case-actions';
import { formatDate } from '../../../actions/global-actions';
import { BsFillTrashFill, BsSearch, BsArrowUp, BsArrowDown } from "react-icons/bs";
import DatePicker from 'react-date-picker';
import Paginator from '../../../components/paginator/paginator';

function LegalityControl(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const [cases, setCases] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const user = useSelector(state => state.user.user);
    const [showContainer, setShowContainer] = useState(false);
    const [skip, setSkip] = useState(0);

    const [paginatorData, setPaginatorData] = useState({
        totalitems: 0,
        totalpages: 0,
        currentpage: 0
    });

    const [form, setForm] = useState({
        date: '',
        filingNumber: '',
        client: '',
        attorney: '',
    })

    useEffect(() => {
        const getFunction = (response) => {
            let data = response.data;
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
            }else{
                //console.log(data.data);
                if (data.data && data.data.length > 0) {
                    for (let index = 0; index < data.data.length; index++) {
                        let type = data.data[index].caseType;
                        data.data[index].caseType = type.charAt(0).toUpperCase() + type.slice(1);

                        if (data.data[index].hasOwnProperty('legalityControl')) {
                            if ( !data.data[index].legalityControl.hasOwnProperty('proof') ) {
                                data.data[index].status = 'No realizado';
                            } else {
                                if (data.data[index].legalityControl.pass) {
                                    data.data[index].status = 'Aprobado';
                                } else {
                                    data.data[index].status = 'Rechazado';
                                }
                            }
                        } else {
                            data.data[index].status = 'No realizado';
                        }
                    }
                }
                setCases(data.data);

                setPaginatorData({
                    ...paginatorData,
                    ...response.headers,
                })
            }
        }

        if (loadData) {
            setLoadData(false);
            setCases([]);
            dispatch( getControls( form, skip, getFunction, user.token ) );
        }
    }, [loadData, dispatch, user.token, form, skip, paginatorData]);

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( form[field] !== '' && form[field] ) {
                    return false
                }
            }
        }
        return true
    }

    const searchFunction = () => {
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar algún campo para continuar",
            });
            return;
        } else {
            stockPaginator();
            setLoadData(true);
        }
    }

    const toggleContainer = () => {
        setShowContainer(!showContainer)
    }
    
    const handleDateChange = ( name, date ) => {
        setForm({
            ...form,
            [name] :  date
        })
    }

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const stockPaginator = () => {
        setSkip(0);
        setPaginatorData({
            totalitems: 0,
            totalpages: 0,
            currentpage: 0
        });
    }

    const deleteSearch = () => {
        setForm({
            date: '',
            filingNumber: '',
            client: '',
            attorney: '',
        })
        stockPaginator();
        setLoadData(true);
    }

    useEffect(() => {
        //console.log(form);
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Control de legalidad</h1>
                <div className="d-flex flex-column w-100">
                    <div onClick={toggleContainer} style={{ width: 'fit-content', cursor: 'pointer'}}>
                        <h4 className="w-100 my-2 d-flex"> Búsqueda
                            {showContainer?
                                <BsArrowUp className="arrow-icon"/>
                            :
                                <BsArrowDown className="arrow-icon"/>
                            }
                        </h4>
                    </div>
                    {showContainer?
                        <div className="w-100 d-flex"> 
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field">Fecha</label>
                                <DatePicker
                                    value={ form.date }
                                    dayAriaLabel={"Día"}
                                    dayPlaceholder={"dd"}
                                    monthAriaLabel={"Mes"}
                                    monthPlaceholder={"mm"}
                                    yearAriaLabel={"Año"}
                                    yearPlaceholder={"yyyy"}
                                    name={"date"}
                                    onChange={ (date)=>handleDateChange( 'date', date ) }
                                    dateFormat="MM/dd/yyyy"
                                />
                            </div>
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field" htmlFor="filingNumber">Radicado</label>
                                <input type="text" className="input-field" id="filingNumber" name="filingNumber" autoComplete="off" placeholder="No de radicado" onChange={handleInputChange} value={form.filingNumber}></input>
                            </div>
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field" htmlFor="client">Cliente</label>
                                <input type="text" className="input-field" id="client" name="client" autoComplete="off" placeholder="Nombre, apellido o documento" onChange={handleInputChange} value={form.client}></input>
                            </div>
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field" htmlFor="attorney">Abogado</label>
                                <input type="text" className="input-field" id="attorney" name="attorney" autoComplete="off" placeholder="Nombre, apellido o documento" onChange={handleInputChange} value={form.attorney}></input>
                            </div>
                            <div className="d-flex search-button m-2 justify-content-center align-items-center" onClick={searchFunction}>
                                <BsSearch/>
                            </div>
                        </div>
                    :
                        null
                    }
                    {showContainer?
                        <div className="w-100 d-flex justify-content-center my-1">
                            <span className="delete-search-text" onClick={deleteSearch}>
                                Eliminar búsqueda
                            </span>
                        </div>
                    :
                        null
                    }
                </div>
                {user.userType === 'Administrador' ?
                    <table className="list-table my-3">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Radicado</th>
                                <th>Tipo Inv.</th>
                                <th>Abogado</th>
                                <th>Cliente</th>
                                <th>Detalles</th>
                                <th>Estado</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {cases.map((caseItem, index) => (
                                <tr key={index}>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{ (index+1) + skip }</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id} className='inline-text'>{formatDate(caseItem.date, 4)}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id} className='inline-text'>{caseItem.filingNumber}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{caseItem.caseType}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{caseItem.attorneyInCharge.userId.firstName} {caseItem.attorneyInCharge.userId.lastName}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{caseItem.client.clientId.firstName} {caseItem.client.clientId.lastName}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{caseItem.case.position} No.{caseItem.autoOpening}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{caseItem.status}</Link> </td>
                                    <td>
                                        <BsFillTrashFill className='trash-icon' />
                                    </td>
                                </tr> 
                            ))}
                        </tbody>
                    </table>
                :
                    <table className="list-table my-3">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Radicado</th>
                                <th>Tipo Inv.</th>
                                <th>Abogado</th>
                                <th>Cliente</th>
                                <th>Detalles</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cases.map((caseItem, index) => (
                                <tr key={index}>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{ (index+1) + skip }</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id} className='inline-text'>{formatDate(caseItem.date, 4)}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id} className='inline-text'>{caseItem.filingNumber}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{caseItem.caseType}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{caseItem.attorneyInCharge.userId.firstName} {caseItem.attorneyInCharge.userId.lastName}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{caseItem.client.clientId.firstName} {caseItem.client.clientId.lastName}</Link> </td>
                                    <td> <Link to={currentLink + `/control/${caseItem._id}`} key={caseItem._id}>{caseItem.case.position} No.{caseItem.autoOpening}</Link> </td>
                                </tr> 
                            ))}
                        </tbody>
                    </table>
                }
                {paginatorData.totalpages > 0 && paginatorData.currentpage > 0? 
                    <Paginator skip={skip} data={paginatorData} setSkip={(n) => setSkip(n)} setLoadData={(need) => setLoadData(need)} />
                :
                    null
                }
            </div>
        </div>
    );
}

export default LegalityControl;
  